"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _UINestedNavItem = _interopRequireDefault(require("UIComponents/nav/UINestedNavItem"));

var _UIRouterLink = _interopRequireDefault(require("./UIRouterLink"));

var pickNestedNavItemProps = function pickNestedNavItemProps(props) {
  var nestedNavProps = Object.keys(_UINestedNavItem.default.propTypes);
  return nestedNavProps.reduce(function (prev, propName) {
    return (0, _extends3.default)({}, prev, (0, _defineProperty2.default)({}, propName, props[propName]));
  }, {});
};

var UIRouterNestedNavItem = _react.default.createClass({
  displayName: "UIRouterNestedNavItem",
  contextTypes: {
    router: _react.PropTypes.object
  },
  getInitialState: function getInitialState() {
    return {
      hasActiveChild: false
    };
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    var _this = this;

    if (this.props.to == null && this.props.children) {
      _react.Children.forEach(this.props.children, function (child) {
        if (_this.context.router.isActive(child.props ? child.props.to : {}, false)) {
          _this.setState({
            hasActiveChild: true
          });
        }
      });
    }
  },
  render: function render() {
    if (this.props.to == null) {
      var defaultOpen = this.props.defaultOpen == null ? this.state.hasActiveChild : this.props.defaultOpen;
      return _react.default.createElement(_UINestedNavItem.default, (0, _extends3.default)({}, pickNestedNavItemProps(this.props), {
        defaultOpen: defaultOpen
      }));
    }

    return _react.default.createElement(_UINestedNavItem.default, (0, _extends3.default)({}, this.props, {
      onlyActiveOnIndex: this.props.onlyActiveOnIndex,
      activeClassName: "private-nav-item--active",
      linkComponent: _UIRouterLink.default
    }));
  }
});

UIRouterNestedNavItem.propTypes = (0, _extends3.default)({}, _UIRouterLink.default.propTypes, _UINestedNavItem.default.propTypes);
UIRouterNestedNavItem.defaultProps = (0, _extends3.default)({}, _UIRouterLink.default.defaultProps, _UINestedNavItem.default.defaultProps, {
  defaultOpen: undefined,
  onlyActiveOnIndex: true
});
var _default = UIRouterNestedNavItem;
exports.default = _default;
module.exports = exports.default;